import { WBFlex, WBIcon, WBIconButton } from '@admiin-com/ds-web';
import { useMediaQuery } from '@mui/material';
import { Theme, useTheme } from '@mui/system';
import LoadSvgIcon from '../../../../../../component/LoadSvgIcon/LoadSvgIcon';
import { SupportDialogButton } from './SupportDialogButton';
// import NotificationRedIcon from 'apps/react-app/src/assets/icons/notification-red.svg';
// import NotificationIcon from 'apps/react-app/src/assets/icons/notification.svg';
import SearchIcon from '../../../../../../../assets/icons/zoom.svg';
import VerificationDangerIcon from '../../../../../../../assets/icons/verfication-danger.svg';
import { AvatarMenu } from './AvatarMenu';
import { useCurrentUser } from '../../../../../../hooks/useCurrentUser/useCurrentUser';
import { useModal } from '../../../../../components/ModalManager/ModalContext';
import { useSelectedEntity } from '../../../../../../hooks/useSelectedEntity/useSelectedEntity';
import { needsEntityVerification } from '../../../../../../helpers/entities';
import { Entity } from '@admiin-com/ds-graphql';

interface Props {
  hasUnreadNotifications?: boolean;
}

// const NotificationIconItem = ({
//   hasUnreadNotifications,
// }: {
//   hasUnreadNotifications?: boolean;
// }) => {
//   const theme = useTheme();
//   return hasUnreadNotifications ? (
//     <LoadSvgIcon
//       component={NotificationRedIcon}
//       width={24}
//       height={24}
//       fill={theme.palette.text.primary}
//     />
//   ) : (
//     <LoadSvgIcon
//       component={NotificationIcon}
//       width={24}
//       height={24}
//       fill={theme.palette.text.primary}
//     />
//   );
// };

const SettingsButton = () => {
  const { openModal } = useModal();
  return (
    <WBIconButton onClick={() => openModal('settings')} color="inherit">
      <WBIcon name="Settings" size="small" />
    </WBIconButton>
  );
};

interface EntityVerificationIconButtonProps {
  entity: Entity | undefined;
  onVerificationComplete?: () => void | Promise<unknown>;
}

const EntityVerificationIconButton = ({
  entity,
  onVerificationComplete,
}: EntityVerificationIconButtonProps) => {
  const { openModal } = useModal();

  if (!needsEntityVerification(entity)) {
    return null;
  }

  const handleClick = () => {
    if (!entity) {
      return;
    }

    openModal('entityVerification', {
      entity,
      onSuccess: () => {
        if (onVerificationComplete) {
          void onVerificationComplete();
        }
      },
    });
  };

  return (
    <WBIconButton onClick={handleClick} color="inherit">
      <LoadSvgIcon component={VerificationDangerIcon} width={24} height={24} />
    </WBIconButton>
  );
};
function getDisplayName(
  name = '',
  prefix = 'The Trustee For ',
  maxLength = 20
): string {
  const stripped = name.startsWith(prefix) ? name.slice(prefix.length) : name;
  return stripped.length > maxLength
    ? `${stripped.slice(0, maxLength)}…`
    : stripped;
}

const RightItemsDesktop = ({ hasUnreadNotifications }: Props) => {
  const user = useCurrentUser();
  const { entity, refetch } = useSelectedEntity();
  const { firmId } = user || {};
  const { openModal } = useModal();
  const displayName = getDisplayName(entity?.name);

  return (
    <WBFlex gap={1} alignItems={'center'}>
      {/*<NotificationIconItem hasUnreadNotifications={hasUnreadNotifications} />*/}
      <EntityVerificationIconButton
        entity={entity}
        onVerificationComplete={() => refetch()}
      />
      <SupportDialogButton />
      <SettingsButton />
      <AvatarMenu
        showName
        name={displayName}
        isFirm={!!firmId}
        logo={entity?.logo ?? null}
        onClick={() => !firmId && openModal('searchMobile')}
      />
    </WBFlex>
  );
};

const RightItemsMobile = ({ hasUnreadNotifications }: Props) => {
  const user = useCurrentUser();
  const { entity, refetch } = useSelectedEntity();
  const { firmId } = user || {};
  const theme = useTheme();
  const { openModal } = useModal();

  const displayName = getDisplayName(entity?.name);

  return (
    <WBFlex alignItems={'center'} gap={0}>
      {firmId && (
        <WBIconButton onClick={() => openModal('searchMobile')}>
          <LoadSvgIcon
            component={SearchIcon}
            width={24}
            height={24}
            fill={theme.palette.text.primary}
          />
        </WBIconButton>
      )}
      <EntityVerificationIconButton
        entity={entity}
        onVerificationComplete={() => refetch()}
      />
      <SettingsButton />
      {/*<NotificationIconItem hasUnreadNotifications={hasUnreadNotifications} />*/}
      <AvatarMenu
        name={displayName}
        isFirm={!!firmId}
        logo={entity?.logo ?? null}
        onClick={() => !firmId && openModal('searchMobile')}
      />
    </WBFlex>
  );
};

export default function RightItems({ hasUnreadNotifications }: Props) {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md')
  );
  return isMobile ? (
    <RightItemsMobile />
  ) : (
    <RightItemsDesktop hasUnreadNotifications={hasUnreadNotifications} />
  );
}
